import { InjectionToken } from '@angular/core';
import { BillingScope } from './billing-consts';

export interface PicflowCheckout {
  open(scope: BillingScope): void;
}

export const PICFLOW_CHECKOUT = new InjectionToken<PicflowCheckout>('PicflowCheckout');
